import {
  FETCH_TOPAGENCIES_SUCCESS,
  FETCH_TOPAGENCIES_REQUEST,
  FETCH_TOPAGENCIES_FAILURE,
  UPDATE_TOPAGENCIES_REQUEST,
  UPDATE_TOPAGENCIES_SUCCESS,
  UPDATE_TOPAGENCIES_FAILURE,
  SHOW_TOPAGENCIES_EDIT_FORM,
  DELETE_TOPAGENCIES_REQUEST,
  DELETE_TOPAGENCIES_SUCCESS,
  DELETE_TOPAGENCIES_FAILURE,
  SET_TOPAGENCIES_VALIDATION_ERRORS,
  SHOW_TOPAGENCIES_NEW_FORM,
  CREATE_TOPAGENCIES_REQUEST,
  CREATE_TOPAGENCIES_SUCCESS,
  CREATE_TOPAGENCIES_FAILURE,
} from "constants/TopAgencies";

const initState = {
  loading: false,
  list: [],
  errorMessage: "",
};

const topagencies = (state = initState, action) => {
  switch (action.type) {
    case FETCH_TOPAGENCIES_REQUEST:
      return {
        ...state,
        loading: true,
        showEditForm: false,
        showNewForm: false,
      };
    case FETCH_TOPAGENCIES_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
      };
    case FETCH_TOPAGENCIES_FAILURE:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };

    default:
      return state;
  }
};

export default topagencies;
